import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TickerStrip from "@/components/TickerStrip";
import LiveStats from "@/components/LiveStats";
import About from "@/components/About";
import Tokenomics from "@/components/Tokenomics";
import ChartEmbed from "@/components/ChartEmbed";
import Roadmap from "@/components/Roadmap";
import HypeSection from "@/components/HypeSection";
import Community from "@/components/Community";
import Footer from "@/components/Footer";

export default function LandingPage() {
  useEffect(() => {
    // Spotlight hover effect for .card-neon
    const onMove = (e) => {
      const cards = document.querySelectorAll(".card-neon");
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const mx = ((e.clientX - rect.left) / rect.width) * 100;
        const my = ((e.clientY - rect.top) / rect.height) * 100;
        if (mx >= 0 && mx <= 100 && my >= 0 && my <= 100) {
          card.style.setProperty("--mx", `${mx}%`);
          card.style.setProperty("--my", `${my}%`);
        }
      });
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-[#05050A] text-white font-body"
    >
      <Navbar />
      <Hero />
      <TickerStrip />
      <LiveStats />
      <About />
      <Tokenomics />
      <ChartEmbed />
      <Roadmap />
      <HypeSection />
      <Community />
      <Footer />
    </main>
  );
}
